"use client";

// Кнопка «Share article»: системный share, иначе копирование ссылки.
export function BlogShareButton({
  cls,
  title,
  label = "Share article",
}: {
  cls: string;
  title: string;
  label?: string;
}) {
  const onClick = () => {
    const url = window.location.href;
    if (navigator.share) {
      navigator.share({ title, url }).catch(() => {});
    } else {
      navigator.clipboard?.writeText(url).catch(() => {});
    }
  };
  return (
    <button type="button" className={`${cls}shareButton`} onClick={onClick}>
      <span>{label}</span>
      <img
        alt=""
        aria-hidden="true"
        className={`${cls}actionIcon`}
        src="/icons/blog/share.svg"
      />
    </button>
  );
}
